import React, { useState, useEffect } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  formControl: {
    width: "100%",
  },
  selectEmpty: {
    marginTop: 8,
  },
});

function PitcherSearch(props) {
  const [pitchers, setPitchers] = useState([]);
  const [selectedPitcher, setSelectedPitcher] = useState("");

  const classes = useStyles();

  useEffect(() => {
    const fetchPitchers = async () => {
      const url = process.env.REACT_APP_API2_URL + "/Game/Pitcher_GetList";
      try {
        const response = await axios.get(url);
        const data = response.data.map((pitcher) => ({
          ...pitcher,
          PitcherName: pitcher.PitcherName.trim(), // Remove any leading or trailing whitespace
        }));
        setPitchers(data);
        // Check if the initial value is among the fetched data
        if (
          props.initialValue &&
          data.some(
            (pitcher) =>
              pitcher.PitcherName.toUpperCase() === props.initialValue.trim()
          )
        ) {
          setSelectedPitcher(props.initialValue.trim());
        } else {
          setSelectedPitcher("");
        }
      } catch (error) {
        console.error("Error fetching the pitchers list:", error);
      }
    };

    fetchPitchers();
  }, [props.initialValue]);

  const handleIdBookChange = (event) => {
    const newValue = event.target.value;
    props.setPitcherOnMem(newValue);
    setSelectedPitcher(newValue);
  };

  const printInputList = () => {
    return (
      <div>
        <FormControl
          className={classes.formControl}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Pitcher
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedPitcher}
            onChange={handleIdBookChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            {pitchers &&
              pitchers.map((row) => (
                <MenuItem
                  key={row.PitcherName}
                  value={row.PitcherName.toUpperCase()}
                >
                  {row.PitcherName}
                </MenuItem>
              ))}
          </Select>
          <FormHelperText>Pitchers</FormHelperText>
        </FormControl>
      </div>
    );
  };

  if (props.isInput) {
    return printInputList();
  }

  return null;
}

PitcherSearch.propTypes = {
  initialValue: PropTypes.string,
  isInput: PropTypes.bool.isRequired,
  setPitcherOnMem: PropTypes.func.isRequired,
};

export default PitcherSearch;
